module.exports = __webpack_public_path__ + "res/Roboto-Italic-webfont.eot?ceca5bb409e1682e410cb760e50d1273";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Italic-webfont.eot
// module id = 21
// module chunks = 0